import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TransitionLink from './TransitionLink';
import { useAuth } from '../store/auth.tsx';

export function RootHeader({ title, trailing }: { title?: string | null; trailing?: ReactNode }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const letter = user?.name?.trim().charAt(0) ?? '';

  return (
    <header className="flex items-center justify-between gap-3 mb-6">
      {title ? <h1 className="page-title min-w-0 truncate">{title}</h1> : null}
      <div className="ml-auto flex items-center gap-2 shrink-0">
        {trailing}
        <TransitionLink
          to="/profile"
          state={{ from: `${location.pathname}${location.search}` }}
          aria-label={t('Профиль')}
          className="w-10 h-10 rounded-full bg-primary-soft text-primary font-bold flex items-center justify-center"
        >
          {letter}
        </TransitionLink>
      </div>
    </header>
  );
}
